export default __webpack_public_path__ + "static/media/fax_icon.5838b6db.svg";